export const ErrorCodes = (componentInstance) => {
    return {
        'common': {
            icon: {
                name: 'warning',
                size: 'xxlarge',
                color: 'warning',
            },
            title: 'twitch.requestFailed',
            subtitle: 'twitch.noBitsSpent',
        },
        '429': {
            icon: {
                name: 'timer',
                size: 'xxlarge',
                color: 'warning',
            },
            title: 'twitch.panel.waitToChange',
            component: {
                name: 'expiration-time',
                props: {
                    'voice-unique-id': componentInstance?.getId(),
                },
            },
        },
    };
};

export default ErrorCodes;
